import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import Apis from '@/Apis/_'

@Module({ namespaced: true, name: 'SuporteGrupoRepassesRemuneracaoStore' })
export default class SuporteGrupoRepassesRemuneracaoStore extends VuexModule {
    gruposRepasses: any[] = []

    @Mutation
    setGruposRepasses(gruposRepasses: any[]) {
        this.gruposRepasses = gruposRepasses
    }

    @Action
    async getGruposRepasses() {
        const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getGruposRepasses()
        if (response.success) {
            this.setGruposRepasses(response.data || [])
        }
        return response
    }

    @Action
    async criarAtualizarGrupoRepasse(params: any) {
        const isCriacao = !params.id
        let body = {
            nome: params.nome,
        }

        if(!isCriacao) {
            body = { ...params, id: params.id }
        }

        try {
            const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.updateGrupoRepasse(body)
            return response
        } catch (error) {
            return { success: false, message: 'Erro ao criar grupo de repasse.' }
        }
    }
}